export function isAccountAreaNotification(notification) {
  if (!notification) return false;

  const module = String(notification.module || "").toLowerCase();
  if (module === "account" || module.includes("account")) {
    return true;
  }

  if (notification.taskId) {
    const content = String(notification.content || "").toLowerCase();
    if (content.includes("payment verification")) {
      return true;
    }
  }

  return false;
}

export function getAccountAreaNotifications(notificationsList) {
  const list = notificationsList?.content ?? notificationsList ?? [];
  const items = Array.isArray(list) ? list : [];
  return items.filter(isAccountAreaNotification);
}

export function countUnreadAccountAreaNotifications(notificationsList) {
  return getAccountAreaNotifications(notificationsList).filter((n) => !n?.read).length;
}
